import { PagedCollectionQuery } from './../query/paged-collection-query';
import { ListFilterSettings, ListPaginationSettings, QuickListDataSourceBase } from './quick-list-data-source.service-base';

export type QuickListFilterMethod<Titem> = (filterSettings: ListFilterSettings, paginationSettings: ListPaginationSettings) => Promise<Titem[]>;

export const quickListFilterMethod = <TQuery extends PagedCollectionQuery<TItem>, TItem>(dataSource: QuickListDataSourceBase<TQuery, TItem>): QuickListFilterMethod<TItem> => {
    return (filterSettings, paginationSettings) => dataSource.quickListAsync(paginationSettings, filterSettings);
};
 